import React from "react";
import useEntity from "../../../hooks/useRoadCarrier";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import { CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./RoadCarrierListHeader";
import EntityListSearch from "./RoadCarrierListSearch";
import {useLocation} from "react-router";
import RoadCarrierListPagination from "./RoadCarrierListPagination";
import * as Api from "../../../apis/RoadCarrier.api";
import { RoadCarrier } from "../../../types/models/RoadCarrier";
import { PrimaryRoadCarrier } from "../../../types/models/RoadCarrier";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import AddressLink from "../../../../address/components/address/AddressDetail/AddressLink";
import AddressName from "../../../../address/components/address/AddressDetail/AddressName";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import RoadCarrierListItemTools from "./RoadCarrierListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    name?: string,
    };

const RoadCarrierListItem = (props: IProps) => {
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('RoadCarrier')

    
    
    
    
    const [, setSearchInputValue, searchInputTerm] = useSearchDebounce();
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetRoadCarrierPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    name: searchInputTerm || '',
                    nameOr: true,
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: RoadCarrier) => routeLocation.pathname.endsWith('road-carriers') ?
        `${PrimaryRoadCarrier.fromEntity(entity).toPath()}`
        :
        `road-carriers/${PrimaryRoadCarrier.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: RoadCarrier) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                <EntityListSearch
                    setSearchInputValue={setSearchInputValue}
                    
                    query={query}
                    refetch={refetch}
                />
                <TableContainer>

                    

                    

                    

                    

                    
        
                    
                        <Table stickyHeader data-testid="RoadCarrier-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'name') }
                                            direction={ orderBys.find((item) => item.name === 'name')?.direction || 'asc' }
                                            onClick={() => toggleOrder('name')}
                                        >
                                        
                                            <Trans>Name</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryRoadCarrier.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.name || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <RoadCarrierListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Road Carriers</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <RoadCarrierListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default RoadCarrierListItem;
